// componentImports.js
import MemberTable from '../Components/MemberTable';
//DataGrid1
import DataGrid1 from '../Components/DataGrid1';

export default { MemberTable, DataGrid1 }